import { render } from "./PanelCollapse.vue?vue&type=template&id=07179bd0&scoped=true"
import script from "./PanelCollapse.vue?vue&type=script&lang=js"
export * from "./PanelCollapse.vue?vue&type=script&lang=js"

import "./PanelCollapse.vue?vue&type=style&index=0&id=07179bd0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07179bd0"

export default script